import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import CheckInDependentPerson from "app/PatientManagement/CheckInList/Popup/CheckInDependentPerson";
import CheckInGeneralPopup from "app/PatientManagement/CheckInList/Popup/CheckInGeneralPopup";
import PopupDuplicate from "app/PatientManagement/CheckInList/Popup/PopupDuplicate";
import LeadSearchPopup from "app/PatientManagement/PatientList/Popup/LeadSearchPopup";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";
import ListAdviseItemsBlock from "./ListAdviseItemsBlock";
import ListAppointmentBlock from "./ListAppointmentBlock";
import ListCardBlock from "./ListCardBlock";
import ListCheckInBlock from "./ListCheckInBlock";
import ListNoteBlock from "./ListNoteBlock";
import ListProductDrug from "./ListProductDrugBlock";
import ListRecentDiagnosticReportImages from "./ListRecentDiagnosticReportImages";
import ListRelationshipBlock from "./ListRelationshipBlock";
import ListSalesInteraction from "./ListSalesInteraction";
import ListServiceBlock from "./ListServiceBlock";
import ListServiceRequestItemBlock from "./ListServiceRequestItemBlock";
import ListVoucherPayment from "./ListVoucherPayment";

const GeneralInfomationBlockIndex = () => {
  const {
    handleGetPatientOverviewById,
    initialPatient,
    setCurrentTab,
    handleGetPatientOverviewByIdNotLoading,
  } = useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const { handleOpenFormCheckIn } =
    useStore().patientManagementStore.patientListStore;

  const {
    initialCheckIn,
    openCheckin,
    handleCloseCheckinPopup,
    openCheckInDependentPersonPopup,
    handleCloseCheckInDependentPersonPopup,
    initCheckInDependentPerson,
    saveCheckCompanions,
    handleChangeFormSearchDependentPerson,
    customerSourceForCompanionDefault,
    openPopupCheckDuplicateDependentPerson,
    handleClosePopupCheckDuplicateDependentPerson,
    duplicatePatients,
    searchDuplicatePatient,
    handleSelectDuplicateDependentPerson,
    openPopupSearchLead,
    handleClosePopupSearchLead,
    handleSelectLeadPatient,
    handleChangeFormSearchDuplicate,
    openSearchLead,
    handleCloseSearchListPopup,
    leadPatient,
    handleSelectLeadSelectLeadPersonal,
    handleSearchDuplicateInPersonal,
    openPopupSearchDependentPersonLead,
    handleClosePopupSearchDependentPersonLead,
    handleSelectDependentPersonLeadPatient,
    handleChangeFormSearchDependentOnlyLead
  } = useStore().patientManagementStore.checkInListStore;

  const { handleOpenCreateOrEditServicePopup } =
    useStore().patientManagementStore.registerServiceStore;
  const { handleOpenCreateOrEditCardPopup } =
    useStore().patientManagementStore.registerProductStore;

  const { getTreatmentFree } =
    useStore().patientManagementStore.registerTreatmentPlanStore;

  useEffect(() => {
    if (patientId) {
      handleGetPatientOverviewById(patientId);
      getTreatmentFree();
      // getDefaultFreePromotion();
    }
  }, [patientId]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <>
      {!isMobile ? (
        <Grid container spacing={1}>
          {/* Lịch sử check in */}
          <Grid item xs={12} lg={4}>
            <ListCheckInBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
            {openCheckin && (
              <CheckInGeneralPopup
                handleAfterSubmit={() => {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 500);
                }}
              />
            )}

            {openCheckInDependentPersonPopup && (
              <CheckInDependentPerson
                open={openCheckInDependentPersonPopup}
                onClose={() => {
                  handleCloseCheckInDependentPersonPopup();
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 500);
                }}
                initCheckInDependentPerson={initCheckInDependentPerson}
                saveCheckCompanions={saveCheckCompanions}
                handleChangeFormSearchDependentPerson={
                  handleChangeFormSearchDependentPerson
                }
                customerSourceForCompanionDefault={
                  customerSourceForCompanionDefault
                }
                handleChangeFormSearchDependentOnlyLead={handleChangeFormSearchDependentOnlyLead}
              />
            )}

            {openPopupCheckDuplicateDependentPerson && (
              <PopupDuplicate
                open={openPopupCheckDuplicateDependentPerson}
                handleClose={handleClosePopupCheckDuplicateDependentPerson}
                duplicatePatients={duplicatePatients}
                searchCheckIn={searchDuplicatePatient}
                onSelectPatient={handleSelectDuplicateDependentPerson}
                handleChangeFormSearch={handleChangeFormSearchDependentPerson}
              />
            )}

            {openPopupSearchDependentPersonLead && (
              <LeadSearchPopup
                open={openPopupSearchDependentPersonLead}
                handleClose={handleClosePopupSearchDependentPersonLead}
                leadPatient={duplicatePatients}
                searchLead={searchDuplicatePatient}
                handleSelect={handleSelectDependentPersonLeadPatient}
                handleChangeFormSearch={handleChangeFormSearchDependentPerson}
              />
            )}

            {openPopupSearchLead && (
              <LeadSearchPopup
                open={openPopupSearchLead}
                handleClose={handleClosePopupSearchLead}
                leadPatient={duplicatePatients}
                searchLead={searchDuplicatePatient}
                handleSelect={handleSelectLeadPatient}
                handleChangeFormSearch={handleChangeFormSearchDuplicate}
              />
            )}

            {/* Chỗ này hiện popup search lead khi chỉnh sửa checkin */}
            {openSearchLead && (
              <LeadSearchPopup
                open={openSearchLead}
                handleClose={handleCloseSearchListPopup}
                leadPatient={leadPatient}
                searchLead={searchDuplicatePatient}
                handleSelect={handleSelectLeadSelectLeadPersonal}
                handleChangeFormSearch={handleSearchDuplicateInPersonal}
              />
            )}
          </Grid>

          {/* Danh sách lịch hẹn*/}
          <Grid item xs={12} lg={4}>
            <ListAppointmentBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/*Payment*/}
          <Grid item xs={12} lg={4}>
            <ListVoucherPayment
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <ListNoteBlock
              setCurrentTab={setCurrentTab}
              initialPatient={initialPatient}
            />
          </Grid>
          {/* tương tác của sales */}
          <Grid item xs={12} lg={4}>
            <ListSalesInteraction initialPatient={initialPatient} />
          </Grid>

          {/* Tư vấn gần đây*/}
          <Grid item xs={12} lg={4}>
            <ListAdviseItemsBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
          </Grid>

          {/* Danh sách dịch vụ*/}
          <Grid item xs={12} lg={6}>
            <ListServiceBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenCreateOrEditServicePopup={
                handleOpenCreateOrEditServicePopup
              }
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/* Danh sách thẻ liệu trình*/}
          {/* <Grid item xs={12} lg={6}>
            <ListTreatmentPlanBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid> */}
          {/* danh sách sản phẩm thuốc */}
          <Grid item xs={12} lg={6}>
            <ListProductDrug
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenCreateOrEditProductPopup={
                handleOpenCreateOrEditCardPopup
              }
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>
          {/* Danh sách vật tư  */}
          {/* <Grid item xs={12} lg={6}>
            <ListMedicalSupply
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenCreateOrEditProductPopup={
                handleOpenCreateOrEditMedicalPopup
              }
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid> */}

          {/* Danh sách thẻ*/}
          <Grid item xs={12} lg={6}>
            <ListCardBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>
          {/* Danh sách điều trị*/}

          <Grid item xs={12} lg={6}>
            <ListServiceRequestItemBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <ListRecentDiagnosticReportImages setCurrentTab={setCurrentTab} />
          </Grid>

          <Grid item xs={12} lg={6} key={patientId}>
            <ListRelationshipBlock initialPatient={initialPatient} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={1}>
          {/* Lịch sử check in */}
          <Grid item xs={12} lg={4}>
            <ListCheckInBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
            {openCheckin && (
              <CheckInGeneralPopup
                open={openCheckin}
                onClose={() => handleCloseCheckinPopup(false)}
                handleAfterSubmit={() => {
                  setTimeout(() => {
                    handleGetPatientOverviewByIdNotLoading(patientId);
                  }, 500);
                }}
                initialValues={initialCheckIn}
              />
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <ListNoteBlock
              setCurrentTab={setCurrentTab}
              initialPatient={initialPatient}
            />
          </Grid>
          {/* tương tác của sales */}
          <Grid item xs={12} lg={4}>
            <ListSalesInteraction initialPatient={initialPatient} />
          </Grid>

          {/* Danh sách lịch hẹn*/}
          <Grid item xs={12} lg={4}>
            <ListAppointmentBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/* Danh sách dịch vụ*/}
          <Grid item xs={12} lg={4}>
            <ListServiceBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenCreateOrEditServicePopup={
                handleOpenCreateOrEditServicePopup
              }
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/* Danh sách điều trị*/}
          <Grid item xs={12} lg={6}>
            <ListServiceRequestItemBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/*Payment*/}
          <Grid item xs={12} lg={4}>
            <ListVoucherPayment
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
          </Grid>

          {/* Tư vấn gần đây*/}
          <Grid item xs={12} lg={4}>
            <ListAdviseItemsBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenFormCheckIn={handleOpenFormCheckIn}
            />
          </Grid>

          {/* danh sách sản phẩm thuốc */}
          <Grid item xs={12} lg={6}>
            <ListProductDrug
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleOpenCreateOrEditProductPopup={
                handleOpenCreateOrEditCardPopup
              }
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          {/* Danh sách thẻ*/}
          <Grid item xs={12} lg={6}>
            <ListCardBlock
              initialPatient={initialPatient}
              setCurrentTab={setCurrentTab}
              handleAfterSubmit={async () => {
                setTimeout(() => {
                  handleGetPatientOverviewByIdNotLoading(patientId);
                }, 500);
              }}
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <ListRecentDiagnosticReportImages setCurrentTab={setCurrentTab} />
          </Grid>

          <Grid item xs={12} lg={6} key={patientId}>
            <ListRelationshipBlock initialPatient={initialPatient} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default memo(observer(GeneralInfomationBlockIndex));
